
import React from 'react';
import { geocodeByPlaceId } from 'react-google-places-autocomplete';
import moment from 'moment';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useDispatch } from 'react-redux';
// import AddressComponent from '../../../../Utils/Address';
import { useProcurationContext } from 'src/Contexts/ProcurationContext';
import useTailwindBrand from 'src/Theme/useTailwindBrand';
import FormInput from 'src/Components/Ui/FormInput';
import FormDate from 'src/Components/FormFields/FormDate';
import FormSelect from 'src/Components/FormFields/FormSelect';
import FormSection from 'src/Components/FormFields/FormSection';
import Functions from 'src/Helpers/Functions';
import { validatePhoneNumber } from 'src/Validation/Phone';
import { useProcuration } from 'src/Hooks/useProcuration';
import { FormErrorsFirstPart } from 'src/Hooks/InterfaceProcuration';
import LayoutProcuration from 'src/Components/Procuration/LayoutProcuration';
import InputAddressField from 'src/Components/Ui/InputAddressField';
import { addressFromGeocode } from '../../../../../Utils/googleAddress';
// import AddressRepository from '../../../../Repositories/AddressRepository';


const FirstPartAe = () => {
    const dispatch = useDispatch()
    const context = useProcurationContext()
    const { teachr, prevStep, nextStep, pdfDoc, triggerPdfUpdate, generalProcuration, setPage } = context
    const { classes } = useTailwindBrand()
    // const [address, setAddress] = useState<Address>();
    const {
        formDataFirstPart,
        errorsFirstPart,
        pdfFiledFieldsFirst,
        listeCountries,
        listeNationalities,
        setFormDataFirstPart,
        setErrorsFirstPart,
        handleSelect,
        setGenderField,
        setMaritalStatusField,
        setNationality,
        setCountryField,
        handleChange
    } = useProcuration({ pdfDoc, teachr, triggerPdfUpdate, setPage })

    const values = {
        setField: setFormDataFirstPart,
        error: errorsFirstPart,
        setError: setErrorsFirstPart
    }

    const validate = (): boolean => {
        const phoneError = validatePhoneNumber(Functions.formatPhoneNumber(formDataFirstPart.phone));
        const birthDateValid = formDataFirstPart.birthDate &&
            (typeof formDataFirstPart.birthDate === 'string' ? formDataFirstPart.birthDate.trim() !== '' : moment(formDataFirstPart.birthDate).isValid());

        const newErrors: FormErrorsFirstPart = {
            firstName: formDataFirstPart.firstName.trim() === '' ? 'Veuillez renseigner un prénom' : '',
            lastName: formDataFirstPart.lastName.trim() === '' ? 'Veuillez renseigner un nom de naissance' : '',
            birthDate: !birthDateValid ? 'Veuillez renseigner une date de naissance' : '',
            birthCity: formDataFirstPart.birthCity.trim() === '' ? 'Veuillez renseigner une ville de naissance' : '',
            address: formDataFirstPart.address.trim() === '' ? 'Veuillez renseigner une adresse' : '',
            signCity: formDataFirstPart.signCity.trim() === '' ? 'Veuillez renseigner un lieu' : '',
            gender: formDataFirstPart.gender === 0 ? 'Veuillez sélectionner un genre' : '',
            phone: phoneError || '',
            country: !formDataFirstPart.country || formDataFirstPart.country.trim() === '' ? 'Veuillez sélectionner un pays de naissance' : '',
            nationality: formDataFirstPart.nationality === 0 ? 'Veuillez renseigner votre nationalité' : '',
            maritalStatus: formDataFirstPart.maritalStatus === 0 ? 'Veuillez sélectionner une situation matrimoniale' : ''
        }
        setErrorsFirstPart(newErrors)
        return !Object.values(newErrors).some(error => error !== '')
    }

    const getBirthday = (value: any) => {
        // FormDate callback peut recevoir un objet Dayjs ou null
        let dateValue: string = '';
        if (value) {
            // Si c'est un objet Dayjs, convertir en string format YYYY-MM-DD
            if (typeof value === 'object' && value.format) {
                dateValue = value.format('YYYY-MM-DD');
            } else if (typeof value === 'string') {
                dateValue = value;
            } else if (value instanceof Date) {
                dateValue = moment(value).format('YYYY-MM-DD');
            }
        }

        if (dateValue) {
            setFormDataFirstPart(prev => ({ ...prev, birthDate: dateValue }))
            // Formater la date pour le PDF (format DD/MM/YYYY)
            const pdfDate = moment(dateValue).format('DD/MM/YYYY');
            if (pdfFiledFieldsFirst.birthDateField1) {
                pdfFiledFieldsFirst.birthDateField1.setText(pdfDate);
            }
            if (pdfFiledFieldsFirst.birthDateField2) {
                pdfFiledFieldsFirst.birthDateField2.setText(pdfDate);
            }
            if (errorsFirstPart.birthDate) {
                setErrorsFirstPart(prev => ({ ...prev, birthDate: '' }))
            }
            setPage(1)
            // Déclencher la mise à jour du PDF
            if (triggerPdfUpdate) {
                triggerPdfUpdate();
            }
        }
    }
    

    const getAddress = (value: string) => {
        geocodeByPlaceId(value).then((response) => {
            // const address = response[0].formatted_address
            const addressObj = addressFromGeocode(response[0], "", true);
            addressObj.sessionToken = '';

            // setAddress(addressObj)
            setFormDataFirstPart(prev => ({
                ...prev,
                address: addressObj.formattedAddress,
                addressObj: JSON.parse(JSON.stringify(addressObj))
            }))
            if (pdfFiledFieldsFirst.addressField1) {
                pdfFiledFieldsFirst.addressField1.setText(addressObj.formattedAddress);
            }
            if (pdfFiledFieldsFirst.addressField2) {
                pdfFiledFieldsFirst.addressField2.setText(addressObj.formattedAddress);
            }
            if (errorsFirstPart.address) {
                setErrorsFirstPart(prev => ({ ...prev, address: '' }))
            }
            setPage(1)
            if (triggerPdfUpdate) {
                triggerPdfUpdate();
            }
        }).catch(() => {
            setErrorsFirstPart(prev => ({ ...prev, address: 'Erreur lors de la récupération de l\'adresse' }))
        })
    }

    const handleNext = () => {
        if (validate()) {
            const payload = {
                step: 2,
                secondProc: formDataFirstPart,
                thirdProc: generalProcuration?.thirdProc || {},
                fourthProc: generalProcuration?.fourthProc || {},
                fifthProc: generalProcuration?.fifthProc || {},
                sixthProc: generalProcuration?.sixthProc || {},
                legalRepProc: generalProcuration?.legalRepProc || [],
                seventhProc: generalProcuration?.seventhProc || {},
                eightProc: generalProcuration?.eightProc || {}
            }
            dispatch({ type: 'SET_AE_INFO', payload })
            nextStep(2)
        }
    }


    return (
        <>
        <LayoutProcuration
            title="Votre procuration"
            icon={<AssignmentIcon className={`w-6 h-6 ${classes.primaryText}`} />}
            nextStep={handleNext}
            prevStep={prevStep}
        >
            <FormSection title="Informations personnelles">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <FormInput
                        label="Prénom"
                        type="text"
                        placeholder="Julie"
                        value={formDataFirstPart.firstName}
                        error={errorsFirstPart.firstName}
                        onChange={(e) => handleChange({ field: 'firstName', pdfField: pdfFiledFieldsFirst.firstNameField1, pdfField2: pdfFiledFieldsFirst.firstNameField2 }, e, values, 1)}
                        name="firstName"
                        required
                    />

                    <FormInput
                        label="Nom de naissance"
                        type="text"
                        placeholder="Dupont"
                        value={formDataFirstPart.lastName}
                        error={errorsFirstPart.lastName}
                        onChange={(e) => handleChange({ field: 'lastName', pdfField: pdfFiledFieldsFirst.lastNameField1, pdfField2: pdfFiledFieldsFirst.lastNameField2 }, e, values, 1)}
                        name="lastName"
                        required
                    />
                    <FormDate
                        callback={getBirthday}
                        required={true}
                        error={errorsFirstPart.birthDate}
                        defaultValue={
                            formDataFirstPart.birthDate
                                ? (typeof formDataFirstPart.birthDate === 'string'
                                    ? (formDataFirstPart.birthDate.includes('/')
                                        ? moment(formDataFirstPart.birthDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                                        : formDataFirstPart.birthDate)
                                    : moment(formDataFirstPart.birthDate).format('YYYY-MM-DD'))
                                : ""
                        }
                        className={`border rounded-md ${errorsFirstPart.birthDate ? `${classes.error} ${classes.errorBorder} border-l-4 border-t border-r` : 'hover:border-2 hover:border-gray-400'} `}
                    />

                    <FormInput
                        label="Numéro de téléphone"
                        type="text"
                        placeholder="0X XX XX XX XX"
                        value={formDataFirstPart.phone}
                        error={errorsFirstPart.phone}
                        onChange={(e) => handleChange({ field: 'phone', pdfField: pdfFiledFieldsFirst.phoneField }, e, values, 3)}
                        name="phone"
                        required
                    />
                    <FormSelect
                        callback={(value) => handleSelect(value, 'gender', setGenderField, values, 3)}
                        required={true}
                        error={errorsFirstPart.gender}
                        label="Genre"
                        placeholder="Sélectionner un genre"
                        data={['Femme', 'Homme']}
                        customClass={`bg-white ${classes.fontFamily} py-[6px] shadow-md shadow-[rgba(0,0,0,25%)] text-[16px] border ${errorsFirstPart.gender ? `${classes.errorBorder} border-l-4` : 'hover:border-2 hover:border-gray-400'}`}
                        defaultValue={formDataFirstPart.gender}
                    />
                    <FormSelect
                        callback={(value) => {
                            handleSelect(value, 'nationality', setNationality, values, 3)
                        }}
                        required={true}
                        error={errorsFirstPart.nationality}
                        label="Nationalité"
                        placeholder="Sélectionner votre nationalité"
                        data={listeNationalities}
                        customClass={`bg-white ${classes.fontFamily} py-[6px] shadow-md shadow-[rgba(0,0,0,25%)] text-[16px] border ${errorsFirstPart.nationality ? `${classes.errorBorder} border-l-4` : 'hover:border-2 hover:border-gray-400'}`}
                        defaultValue={
                            typeof formDataFirstPart.nationality === 'number' && formDataFirstPart.nationality >= 1
                                ? formDataFirstPart.nationality
                                : typeof formDataFirstPart.nationality === 'string'
                                    ? (() => {
                                        const idx = listeNationalities.indexOf(formDataFirstPart.nationality as string);
                                        return idx >= 0 ? idx + 1 : 0;
                                    })()
                                    : 0
                        }
                    />
                    <FormInput
                        label="Ville de naissance"
                        type="text"
                        placeholder="Paris"
                        value={formDataFirstPart.birthCity}
                        error={errorsFirstPart.birthCity}
                        onChange={(e) => handleChange({ field: 'birthCity', pdfField: pdfFiledFieldsFirst.birthCityField1, pdfField2: pdfFiledFieldsFirst.birthCityField2 }, e, values, 1)}
                        name="birthCity"
                        required
                    />

                    <FormSelect
                        callback={(value) => {
                            const countryNames = Object.values(listeCountries);
                            const countryName = countryNames[value - 1] ?? '';
                            setFormDataFirstPart((prev) => ({ ...prev, country: countryName }));
                            setCountryField(value);
                            if (errorsFirstPart.country) {
                                setErrorsFirstPart((prev) => ({ ...prev, country: '' }));
                            }
                            if (setPage) setPage(3);
                            if (triggerPdfUpdate) triggerPdfUpdate();
                        }} 
                        required={true}
                        error={errorsFirstPart.country}
                        label="Pays de naissance"
                        placeholder="Sélectionner votre pays de naissance"
                        data={Object.values(listeCountries)}
                        customClass={`bg-white ${classes.fontFamily} py-[6px] shadow-md shadow-[rgba(0,0,0,25%)] text-[16px] border ${errorsFirstPart.country ? `${classes.errorBorder} border-l-4` : 'hover:border-2 hover:border-gray-400'}`}
                        defaultValue={formDataFirstPart.country}
                    />

                    <FormSelect
                        callback={(value) => {
                            handleSelect(value, 'maritalStatus', setMaritalStatusField, values, 3)
                        }}
                        required={true}
                        error={errorsFirstPart.maritalStatus}
                        label="Situation matrimoniale"
                        placeholder="Sélectionner une situation"
                        data={['Célibataire', 'Marié(e)', 'Divorcé(e)', 'Veuf(ve)', 'Pacsé(e)', 'En concubinage']}
                        customClass={`bg-white ${classes.fontFamily} py-[6px] shadow-md shadow-[rgba(0,0,0,25%)] text-[16px] border ${errorsFirstPart.maritalStatus ? `${classes.errorBorder} border-l-4` : 'hover:border-2 hover:border-gray-400'}`}
                        defaultValue={formDataFirstPart.maritalStatus}
                    />
                   

                    <FormInput
                        label="Procuration faite à"
                        type="text"
                        placeholder="Paris"
                        value={formDataFirstPart.signCity}
                        error={errorsFirstPart.signCity}
                        onChange={(e) => handleChange({ field: 'signCity', pdfField: pdfFiledFieldsFirst.signCityField }, e, values, 1)}
                        name="signCity"
                        required
                    />
                </div>
            </FormSection>
            <FormSection title="Adresse de résidence" className="border-gray-200">
                {/* <div className="bg-white border shadow-md rounded-lg py-1 px-2 relative transition-all duration-200">
                    <label className={`block text-sm font-semibold mb-1 ${errorsFirstPart.address ? classes.error : classes.text} ${classes.fontFamily}`}>
                        Adresse {errorsFirstPart.address && <span className={classes.error}>*</span>}
                    </label>
                    <AddressComponent
                        default={formDataFirstPart.address}
                        getPlaceId={getAddress}
                        placeholder="Ex: 2 rue de la Seine, 94004"
                    />
                </div>
                {errorsFirstPart.address && (
                    <p className={`text-sm mt-1 ${classes.error} font-medium`}>{errorsFirstPart.address}</p>
                )} */}
                <InputAddressField
                    label='Adresse'
                    default={formDataFirstPart.address}
                    getPlaceId={getAddress}
                    placeholder="Ex: 2 rue de la Seine, 94004"
                    error={errorsFirstPart.address}
                />
            
            </FormSection>

        </LayoutProcuration>
        </>
    );
};

export default FirstPartAe;
